import React from 'react'
import LanguageSelector from './LanguageSelector'

interface Language {
  key: string
  value: string
}

interface AIInterpretationFieldsProps {
  language: string
  onLanguageChange: (value: string) => void
  languages: Language[]
  loading: boolean
}

const AIInterpretationFields: React.FC<AIInterpretationFieldsProps> = ({
  language,
  onLanguageChange,
  languages,
  loading,
}) => {
  return (
    <LanguageSelector
      selectedLanguage={language}
      onLanguageChange={onLanguageChange}
      languages={languages}
      loading={loading}
    />
  )
}

export default AIInterpretationFields
